import { CalendarDays, User } from 'lucide-react';
import type { PathResolver } from '@/components/layout/workspace/types';
import type { TimeRow, TimeRowGroup } from '@/components/ui/TimeGrid';
import { addCalendarDays, type TimeShift } from '@/lib/timeGrid';
export const HOME = '/design/duty',
  ANCHOR = '2026-10-24',
  NOW = Date.UTC(2026, 9, 24, 10);
export const PEOPLE = [
  { id: 'mira', name: 'Мира Белова' },
  { id: 'lev', name: 'Лев Дёмин' },
  { id: 'nika', name: 'Ника Орлова' },
];
export const ZONES = [
  { id: 'Europe/Moscow', name: 'Москва' },
  { id: 'Asia/Yekaterinburg', name: 'Екатеринбург' },
  { id: 'Europe/Berlin', name: 'Берлин' },
];
export const ROWS: TimeRow[] = [
  { id: 'a-main', title: 'Основной слой' },
  { id: 'a-backup', title: 'Резервный слой' },
  { id: 'b-main', title: 'Первый слой' },
  { id: 'b-backup', title: 'Второй слой' },
];
export const GROUPS: TimeRowGroup[] = [
  { id: 'a', title: 'Расписание А', detail: '2 слоя', rowIds: ['a-main', 'a-backup'] },
  { id: 'b', title: 'Расписание Б', detail: '2 слоя', rowIds: ['b-main', 'b-backup'] },
];
export interface DutyEvent extends TimeShift {
  personId: string;
  createdAt: string;
  authorId: string;
  awaitingId?: string;
}
const clock = (day: string, hour: string) => day + 'T' + hour + ':00+03:00';
export const EVENTS: DutyEvent[] = Array.from({ length: 4 }, (_, period) => {
  const day = addCalendarDays(ANCHOR, period * 14),
    next = addCalendarDays(day, 1),
    later = addCalendarDays(day, 2),
    end = addCalendarDays(day, 3);
  return [
    {
      id: 'duty-' + period + '-1',
      rowId: 'a-main',
      title: 'Дневная смена',
      start: clock(day, '10:00'),
      end: clock(next, '10:00'),
      personId: 'mira',
      authorId: 'nika',
      createdAt: new Date(NOW - 3 * 3600000).toISOString(),
      tone: 'info' as const,
    },
    {
      id: 'duty-' + period + '-2',
      rowId: 'a-backup',
      title: 'Подмена после полуночи',
      start: clock(next, '00:00'),
      end: clock(later, '00:00'),
      personId: 'lev',
      authorId: 'nika',
      createdAt: new Date(NOW - 2 * 3600000).toISOString(),
      tentative: true,
      awaitingId: 'mira',
      tone: 'warning' as const,
    },
    {
      id: 'duty-' + period + '-3',
      rowId: 'a-main',
      title: 'Следующая смена',
      start: clock(next, '10:00'),
      end: clock(later, '10:00'),
      personId: 'nika',
      authorId: 'mira',
      createdAt: new Date(NOW - 5 * 3600000).toISOString(),
      tone: 'info' as const,
    },
    {
      id: 'duty-' + period + '-4',
      rowId: 'a-backup',
      title: 'Резервная смена',
      start: clock(next, '10:00'),
      end: clock(later, '10:00'),
      personId: 'lev',
      authorId: 'mira',
      createdAt: new Date(NOW - 5 * 3600000).toISOString(),
      tone: 'success' as const,
    },
    {
      id: 'duty-' + period + '-5',
      rowId: 'b-main',
      title: 'Первая смена',
      start: clock(day, '08:00'),
      end: clock(next, '08:00'),
      personId: 'nika',
      authorId: 'lev',
      createdAt: new Date(NOW - 7 * 3600000).toISOString(),
      tone: 'info' as const,
    },
    {
      id: 'duty-' + period + '-6',
      rowId: 'b-backup',
      title: 'Вторая смена',
      start: clock(later, '10:00'),
      end: clock(end, '10:00'),
      personId: 'mira',
      authorId: 'lev',
      createdAt: new Date(NOW - 7 * 3600000).toISOString(),
      tone: 'success' as const,
    },
  ];
}).flat();
export const resolveDuty: PathResolver = (path) => {
  const id = path.split('/').at(-1),
    event = EVENTS.find((e) => e.id === id),
    person = PEOPLE.find((p) => p.id === id);
  return {
    type: path === HOME || path === HOME + '/' ? 'view' : 'object',
    serviceId: 'duty-sample',
    title: event?.title ?? person?.name ?? 'Дежурства',
    icon: person ? User : CalendarDays,
    homeView: HOME,
  };
};
